import { maxDeviceWidth } from 'libs/shared/utils/src/utils/MixinUtils';
import styled from 'styled-components';
import tw from 'twin.macro';

import { Radio, RadioGroup } from '@nw/omega-design-system/RadioGroup';

export const StyledRadioGroup = styled(RadioGroup)``;

export const StyledRadio = styled(Radio)``;

export const FieldContainer = styled.div`
  ${tw`w-full`};
  ${(props) => (props.isHidden ? tw`hidden` : tw``)};
  ${(props) => (props.isMarginBottomZero ? tw`mb-0` : tw`mb-1`)};
  ${(props) => props.css}
`;

export const RadioButtonsWrapper = styled.div`
  ${tw`flex`};
  ${(props) => props.css}
`;

export const ChooseUserRoleOption = styled.div<{
  isSelected: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 16px;
  cursor: pointer;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  padding: 8px 42px 0px 16px;
  gap: 16px;
  ${({ isSelected }) =>
    isSelected &&
    `
    background: #F1F5F9;
    color: white;
    border: 1px solid #991B1B;
  `};

  ${maxDeviceWidth(1199)} {
    width: 100%;
  }
`;

export const ChooseUserRoleOptionText = styled.span`
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #334155;
`;

export const ChooseUserRoleOptionIconContainer = styled.div`
  min-width: 52px;
`;

export const ChooseUserRoleOptionIcon = styled.img`
  height: 55px;
  width: 97px;
  margin-right: 8px;
  margin-bottom: -2px;
  @media (max-width: 768px) {
    height: 48px;
    width: 66px;
  }
`;

export const DateSelectionRadio = styled(Radio)`
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid ${(props) => (props.isSelected ? '#991B1B' : '#CBD5E1')};
  background-color: ${(props) => (props.isSelected ? '#F1F5F9' : '#FFFFFF')};
  color: '#475569';
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  white-space: nowrap;
  width: fit-content;
  margin: 0;
  flex: 0 0 auto;

  div > svg {
    display: none;
  }

  .dateSelectionRadio {
    width: fit-content;
  }
`;

export const IconContainer = styled.div``;
